(function(){
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;

  // scroll-reveal
  var els = document.querySelectorAll('.bz-card,.bz-bcard,.bz-rc,.bz-prow,.bz-band,.bz-pd,.bz-asec');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function(el, i){ el.style.transitionDelay = ((i % 3) * 70) + 'ms'; io.observe(el); });
  } else {
    els.forEach(function(el){ el.classList.add('is-in'); });
  }

  // hero parallax
  var wrap = document.querySelector('.bz-hero__imgwrap');
  if (wrap) {
    var ticking = false;
    function upd(){ wrap.style.transform = 'translate3d(0,' + ((window.pageYOffset || 0) * 0.10) + 'px,0)'; ticking = false; }
    window.addEventListener('scroll', function(){ if (!ticking){ requestAnimationFrame(upd); ticking = true; } }, { passive: true });
    upd();
  }
})();
